import React, { useEffect } from 'react'
import { View, ViewStyle, ImageStyle, Image } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useStores } from '@trivie/core'

export const BrandedSplashScreen = observer(() => {
  const { userStore } = useStores()
  const { logoPath, showBrandedSplash, setShowBrandedSplash } = userStore

  useEffect(() => {
    setTimeout(() => {
      setShowBrandedSplash(false)
    }, 2000)
  }, [showBrandedSplash])

  return showBrandedSplash ? (
    <View style={CONTAINER}>
      <View style={SPACER} />
      <Image style={BRANDING} source={{ uri: logoPath }} />
      <View style={FOOTER} />
    </View>
  ) : null
})

/**
 * Styling
 */
const CONTAINER: ViewStyle = {
  backgroundColor: '#fff',
  position: 'absolute',
  justifyContent: 'center',
  flex: 1,
  flexDirection: 'column',
  paddingHorizontal: 60,
  height: '100%',
  width: '100%',
  top: 0,
  left: 0,
  zIndex: 999,
}
const SPACER: ViewStyle = { flex: 1 }
const BRANDING: ImageStyle = {
  height: 500,
  width: 500,
  resizeMode: 'contain',
  alignSelf: 'center',
}
const FOOTER: ViewStyle = { bottom: 60, justifyContent: 'flex-end', flex: 1 }
